import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"scroll-mt-14 bg-[#390261] sm:scroll-mt-32\"><div class=\"overflow-hidden lg:relative\"><div class=\"mx-auto px-4 sm:px-6 md:max-w-2xl md:px-4 lg:max-w-5xl lg:px-8 relative grid grid-cols-1 items-end gap-y-12 py-20 lg:static lg:grid-cols-2 lg:py-28 xl:py-32\"><div class=\"my-auto\"><h1 class=\"mb-0 font-display text-5xl font-extrabold tracking-tight text-white sm:w-3/4 sm:text-6xl md:w-2/3 lg:w-auto\">Ruurtjan Pul</h1><p class=\"mt-4 text-lg tracking-tight text-purple-200\">Before founding NsLookup, Ruurtjan worked as a software and infrastructure engineering consultant at BigData Republic. He now works full-time on NsLookup.</p></div><div><img class=\"object-cover shadow-lg rounded-full ml-auto mr-[auto] max-h-64 border-solid border-white border-2 lg:mr-0\" src=\"/img/ruurtjan-lg.jpg\" alt=\"Ruurtjan Pul\" title=\"Ruurtjan Pul\"></div></div></div></section>", 1)
const _hoisted_2 = { class: "flex-grow scroll-mt-14 sm:scroll-mt-32" }
const _hoisted_3 = { class: "mx-auto px-4 sm:px-6 md:max-w-2xl md:px-4 lg:max-w-5xl lg:px-8 relative py-20 lg:py-28 xl:py-32" }
const _hoisted_4 = { class: "mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Life before NsLookup", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Ruurtjan worked as a software engineering and infrastructure engineering consultant at a small machine learning consultancy firm in The Netherlands, BigData Republic.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "He worked for start-ups, scale-ups and enterprises like the ING bank, Bol.com, Randstad, ProRail, Yolt and TNO.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "During this time, he worked on side projects like NsLookup in the evenings and weekends.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Work on NsLookup", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "https://www.monomatic.io/" }, "Monomatic", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Ruurtjan now spends most of his time working on NsLookup. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Education", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("In 2011, Ruurtjan completed his Bachelor of Science degree in Software Engineering at the Hanze University of Applied Sciences Groningen. He continued his studies in IT at the University of Groningen, where he graduated as a "),
  /*#__PURE__*/_createElementVNode("strong", null, "master of science in Software Engineering and Distributed Systems"),
  /*#__PURE__*/_createTextVNode(" in 2015.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Ruurtjan also holds certifications as a Scala and Java programmer, as well as on Apache Cassandra and Kafka.", -1)

import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import { authorToLdJson, ruurtjan } from '@/common/authors';
import Breadcrumbs from '@/components/layout/BreadcrumbsComponent.vue';
import { aboutBreadcrumb } from '@/model/Breadcrumb';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutRuurtjan',
  setup(__props) {

const breadcrumbs = [aboutBreadcrumb, { url: ruurtjan.url, title: ruurtjan.name }];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "About Ruurtjan Pul",
        description: _unref(ruurtjan).bio.join(' '),
        url: "https://www.nslookup.io/about/ruurtjan-pul/"
      }, null, 8, ["description"]),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(authorToLdJson)(_unref(ruurtjan))), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(HeaderComponent),
    _createVNode(Breadcrumbs, {
      routes: breadcrumbs,
      class: "w-full max-w-5xl mx-auto px-4 pb-5 sm:px-6 lg:px-8"
    }),
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("p", null, [
            _createTextVNode("Early 2022, "),
            _createVNode(_component_router_link, { to: "https://ruurtjan.com/articles/i-quit-my-job" }, {
              default: _withCtx(() => [
                _createTextVNode("Ruurtjan quit his job")
              ]),
              _: 1
            }),
            _createTextVNode(" at BigData Republic to work full-time on his passion projects. He incorporated NsLookup under his company "),
            _hoisted_10,
            _createTextVNode(".")
          ]),
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})